import React, { useState } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import {
  sizeIcon,
} from '../../assets';

const Panel = styled.div`
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
  border-radius: 10px;
  background-color: rgba(0, 141, 65, 0.15);
`;

const RecommendationIcon = styled.img`
  width: auto;
  height:5vw;
  opacity:0.8;

  @media screen and (min-width: 601px) {
    height: 30px;
  }
`;

const RecommendationLabel = styled.span`
  display: inline-block;
  font-family: Inter, sans-serif;
  font-size: 4vw;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
  color: var(--dark-slate-blue);
  opacity:0.8;
  white-space: nowrap;

@media screen and (min-width: 601px) {
  font-size: 25px;
}

  &.arch-type-panel {
    margin: auto;
  }
`;

const RecommendationValue = styled.span`
  display: inline-block;
  font-family: Inter, sans-serif;
  font-size: 8vw;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: -0.8px;
  color: var(--dark-slate-blue);

  &.arch-type-panel {
    flex: 2;
    margin-top: 10px;
  }

  @media screen and (min-width: 601px) {
    font-size: 40px;
  }
`;

export { Panel, RecommendationIcon, RecommendationLabel, RecommendationValue };
